import { render, staticRenderFns } from "./UnitDefectChart.vue?vue&type=template&id=62485745&scoped=true&"
import script from "./UnitDefectChart.vue?vue&type=script&lang=js&"
export * from "./UnitDefectChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62485745",
  null
  
)

export default component.exports